import { render, staticRenderFns } from "./ContractMessage.vue?vue&type=template&id=2b0cdab5&scoped=true"
import script from "./ContractMessage.vue?vue&type=script&lang=js"
export * from "./ContractMessage.vue?vue&type=script&lang=js"
import style0 from "./ContractMessage.vue?vue&type=style&index=0&id=2b0cdab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cdab5",
  null
  
)

export default component.exports